import React, { createContext, useContext } from "react";
import { useCache } from "./CacheContext.hook";
import { ICacheContext } from "./CacheContext.types";

const CacheContext = createContext<ICacheContext | null>(null);

export const CacheProvider = ({
  children,
}: {
  children: React.ReactElement | React.ReactElement[];
}) => {
  const contextValue = useCache();

  return (
    <CacheContext.Provider value={contextValue}>
      {children}
    </CacheContext.Provider>
  );
};

export const useCacheContext = () => useContext(CacheContext) as ICacheContext;
